<template>
    <div id="dashboard" class="fc__view">
        <!-- <div class="dashboard-banner-container">
            <DashboardBanner :switchDate="vuedata.user.dashboard_changed_at" :title="trans('dashboard_single.banner.new_title')" :subtitle="trans('dashboard_single.banner.sub')" />
        </div> -->
        <div v-if="this.retrieving" class="bc__layout__dashboard bc__loading bc__preloader">
            <loader :dim="64"></loader>
            <p>{{ trans('dashboard.general.retrieving') }}</p>
        </div>
        <div v-else class="bc__layout__dashboard" :class="{ dashboard__zero__distrib: !zeroDistrib }">
            <header>
                <greetings :name="vuedata.user_name"></greetings>
                <div class="indexes">
                    <WidgetEBecrop v-if="vuedata.user.client.ebecrop_access" :showImg="false"></WidgetEBecrop>
                    <main-stats :stats="vuedata.main_stats"></main-stats>
                </div>
            </header>
            <main v-if="!zeroDistrib">
                <orphan-cta
                    :widget="widgets2_objs.orphan_samples"
                    :subclients="vuedata.subclients"
                    @click.native="trackWidgetInteraction('Orphan-CTA')"
                />

                <pending-parcels-cta
                    :widget="widgets2_objs.pending_parcels"
                    :subclients="vuedata.subclients"
                    @click.native="trackWidgetInteraction('PendingParcels-CTA')"
                />

                <crop-distro
                    :widget="widgets2_objs.crop_distro"
                    :flag="{ flagSamples: vuedata.main_stats[2].number === 0 }"
                    @click.native="trackWidgetInteraction('CropDistro')"
                />

                <feed
                    :widget="widgets2_objs.action_history"
                    :subclients="vuedata.subclients"
                    @click.native="trackWidgetInteraction('Feed')"
                />

                <last-reports
                    :widget="widgets2_objs.recently_finished"
                    :subclients="vuedata.subclients"
                    @click.native="trackWidgetInteraction('LastReports')"
                />

                <div class="bca__bottom" :class="{ 'bca__bottom--zero': vuedata.main_stats[2].number === 0 }">
                    <disease-overview
                        :widget="widgets2_objs.disease_distro"
                        @click.native="trackWidgetInteraction('DiseaseOverview')"
                    ></disease-overview>
                    <fert-overview
                        :widget="widgets2_objs.lowest_npk"
                        @click.native="trackWidgetInteraction('FertOverview')"
                    ></fert-overview>
                    <parcels-effort
                        :widget="widgets2_objs.parcels_effort"
                        @click.native="trackWidgetInteraction('ParcelsEffort')"
                    ></parcels-effort>
                    <div class="bcw bcw__zero__reports">
                        <div class="zero__inner">
                            <div class="img__cont">
                                <img src="/images/samp.svg" />
                                <div>
                                    <p class="title">
                                        {{ trans('dashboard.zero.widgets.title') }}
                                    </p>
                                    <p class="subtitle">
                                        {{ trans('dashboard.zero.widgets.sub') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <main v-else class="main--zero">
                <zero></zero>
            </main>
        </div>
    </div>
</template>

<style lang="scss" scoped>
#container_of_widgets {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}
</style>

<script>
import Widget from './Widgets/Widget';
import GISTriggerWidget from './Widgets/GISTriggerWidget.vue';
import WidgetEBecrop from '@becrop/components/DashboardSingle/components/WidgetEBecrop.vue';
import DashboardBanner from '@becrop/components/Common/DashboardBanner.vue'

export default {
    components: {
        GISTriggerWidget,
        WidgetEBecrop,
        DashboardBanner
    },

    props: {
        vuedata: {},
    },

    data() {
        return {
            retrieving: true,
            widgets2: this.vuedata.widgets.map((controllerData) => new Widget(controllerData)),
            widgets2_objs: {},
            zeroDistrib: false,
        };
    },

    mounted() {
        this.fetchAllWidgets();
    },

    created() {
        window.mixpanel.track('Dashboard');
    },

    methods: {
        async fetchAllWidgets() {
            // Wait for all widgets to load
            const promises = this.widgets2.map((widget) => widget.load());
            await Promise.all(promises);

            for (const widget of this.widgets2) {
                this.widgets2_objs[widget.url] = widget;
            }

            this.retrieving = false;

            this.zeroDistrib =
                this.vuedata.is_distributor &&
                this.widgets2_objs.recently_finished.datas[0].length === 0 &&
                this.vuedata.main_stats.find((stat) => stat.name === 'Parcels').number === 0;
        },

        trackWidgetInteraction(widgetName) {
            window.mixpanel.track(widgetName + '-wgt');
        },
    },
};
</script>
